export type FilterType = 'list' | 'equals' | 'between';
export type FilterValueType = 'elements' | 'range';
export type RangeBound = number | string | null;
export type SpecialOfferType = 'Installment' | 'Leasing' | 'Rental';

export interface BaseFilter {
  type: FilterType;
}

export interface ListFilter extends BaseFilter {
  type: 'list';
  values: string[];
}

export interface EqualsFilter extends BaseFilter {
  type: 'equals';
  value: string | number | boolean | null;
}

export interface BetweenFilter extends BaseFilter {
  type: 'between';
  from: RangeBound;
  to: RangeBound;
}

export type FilterDefinition = ListFilter | EqualsFilter | BetweenFilter;

export interface FiltersMap {
  [key: string]: FilterDefinition;
}

export interface BaseFilterValue {
  type: FilterValueType;
}

export interface ElementsFilterValue extends BaseFilterValue {
  type: 'elements';
  values: string[];
}

export interface RangeFilterValue extends BaseFilterValue {
  type: 'range';
  from: RangeBound;
  to: RangeBound;
}

export type FilterValueDefinition = ElementsFilterValue | RangeFilterValue;

export interface FilterValuesMap {
  [key: string]: FilterValueDefinition;
}

export interface PropertyDescriptor {
  label: string;
  type: 'String' | 'Numeric' | 'Date';
}

export interface PropertySet {
  [key: string]: PropertyDescriptor;
}

export interface PropertyValues {
  BRAND: string,
  MODEL: string,
  FUEL_TYPE: string,
  BODY_TYPE: string,
  TRANSMISSION_TYPE: string,
  NUMBER_OF_SEATS: number,
  FIRST_REGISTRATION_DATE: string,
  YEAR_OF_PRODUCTION: number,
  ENGINE_MILEAGE: number,
  SUBTYPE: string,
  POWER_HP: number,
  DISPLACEMENT: number
}

export interface Picture {
  fileId: string;
}

export interface ItemLocation {
  voivodeship: string;
  city: string;
}

export interface BasicDescription {
  year: string;
  mileage: string;
  engine: string;
  transmission: string;
}

export interface SpecialOffer {
  price: number | null;
  initialFee: number;
  installment: number;
  durationInMonths: number;
  specialOfferType: SpecialOfferType;
  annualMileageLimit: number;
}

export interface Offering {
  id: string;
  type: string;
  assetId: string;
  auctionId: string | null;
  createdAt: string;
  endingDate: string;
  listableFrom: string | null;
  specialOffer: SpecialOffer;
  startingDate: string;
  availableFrom: string | null;
  canBeInquired: boolean;
  inquiresEmail: string;
  commissionPercentage: number;
}

export interface Metadata {
  seller: {
    isPartner: boolean;
  };
  offering: Offering;
}

export interface PageItem {
  id: string;
  type: string;
  publicationDate: string;
  name: string;
  sellerDetails: any;
  basicDescription: BasicDescription;
  itemLocation: ItemLocation;
  pictures: Picture[];
  whitelistedAccessOnly: boolean;
  listableFrom: string | null;
  metadata: Metadata;
  propertySet: PropertySet;
  propertyValues: PropertyValues;
}

export interface PageResponse<T> {
  content: T[];
  totalElements?: number;
  totalPages?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface SearchResponse {
  filters: FiltersMap;
  filterValues: FilterValuesMap;
  sorting: Record<string, 'ASC' | 'DESC'> | null;
  pageResponse: PageResponse<PageItem>;
}

export interface SearchRequest {
  filters: FiltersMap;
  sorting?: Record<string, 'ASC' | 'DESC'>;
}

export enum AuctionDaysLeftAccent {
  Ordinary = 'ordinary',
  Warn = 'warn',
  Urgent = 'urgent'
}

export interface EndingInfo {
  daysLeft: string;
  accent: AuctionDaysLeftAccent;
}
